import { FunctionComponent } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { ClearFilterButton } from '@cbridge-tools/filters-panel';
import { selectedSymbolGroupsSelector, SymbolGroupsAction } from '@cbridge-packages/symbol-groups';

export const ClearSymbolFilterButton: FunctionComponent = () => {
  const dispatch = useDispatch();
  const selectedSymbolGroup = useSelector(selectedSymbolGroupsSelector);

  const isShown = selectedSymbolGroup?.length > 0;

  const handleClearFilter = () => {
    dispatch(SymbolGroupsAction.clearSelect());
  };

  return (
    <ClearFilterButton
      isShown={isShown}
      onClick={handleClearFilter}
    />
  );
};
